
import React from 'react';
import styles from './DispatchHeader.module.css';

const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  return new Date(dateStr).toLocaleDateString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric'
  });
};

const getTrackingLink = (carrierName, trackingNumber) => {
  if (!carrierName || !trackingNumber) return null;
  const lower = carrierName.toLowerCase();
  if (lower.includes('shree maruti'))
    return `https://trackcourier.io/track-and-trace/shree-maruti-courier/${trackingNumber}`;
  if (lower.includes('bluedart') || lower.includes('blue dart'))
    return `https://trackcourier.io/track-and-trace/blue-dart-courier/${trackingNumber}`;
  return null;
};

const DispatchHeader = ({ 
  headerData, 
  isPdfAvailable, 
  isDownloading, 
  onDownloadInvoice,
  isCOAAvailable,        // NEW
  onDownloadAllCoa,      // NEW
}) => {
  if (!headerData) return null;

  const trackingLink = getTrackingLink(headerData.carrierName, headerData.trackingNumber);

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <h5>Dispatch Details</h5>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.infoGrid}>
          <div className={styles.infoRow}>
            <span className={styles.label}>Our Invoice Number:</span>
            <span>{headerData.invoiceNo} – Dated # {formatDate(headerData.invoiceDate)}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.label}>Customer PO Number:</span>
            <span>{headerData.customerPoNo || 'N/A'}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.label}>Carrier Name:</span>
            <span>{headerData.carrierName || 'N/A'}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.label}>Tracking Number:</span>
            <span>{headerData.trackingNumber || 'N/A'} – Dated # {formatDate(headerData.trackingUpdatedDate)}</span>
          </div>
          {trackingLink && (
            <div className={styles.infoRow}>
              <span className={styles.label}>Track Shipment:</span>
              <a href={trackingLink} target="_blank" rel="noreferrer" className={styles.trackButton}>
                🚚 Track Shipment
              </a>
            </div>
          )}
          <div className={styles.infoRow}>
            <span className={styles.label}>Estimated Delivery Date:</span>
            <span>{formatDate(headerData.deliveryDate)}</span>
          </div>
        </div>

        {/* Download Section */}
        <div className={styles.downloadSection}>
          {isPdfAvailable ? (
            <button
              className={styles.downloadBtn}
              onClick={onDownloadInvoice}
              disabled={isDownloading}
            >
              {isDownloading ? (
                <>
                  <span className={styles.spinner} />
                  Downloading...
                </>
              ) : (
                <>📄 Download Invoice</>
              )}
            </button>
          ) : (
            <button className={styles.downloadBtnDisabled} disabled>
              📄 Invoice Not Available
            </button>
          )}

          {/* NEW: COA bulk download button */}
          {isCOAAvailable ? (
            <button
              className={styles.downloadBtn}
              onClick={onDownloadAllCoa}
            >
              🧪 Download All COA
            </button>
          ) : (
            <button className={styles.downloadBtnDisabled} disabled>
              🧪 COA Not Available
            </button>
          )}

          
        </div>
      </div>
    </div>
  );
};

export default DispatchHeader;